import { render } from 'preact-render-to-string';
import dayjs from 'dayjs';
import { BasicEmailWrapper, Heading, MarketingFooter } from './shared';

export function CheckoutHeartbeatAlert({
  now,
  lastPaidSaleAt,
}: {
  now: Date;
  lastPaidSaleAt?: Date;
}) {
  const hours = lastPaidSaleAt
    ? Math.round(dayjs(now).diff(lastPaidSaleAt, 'hour', true))
    : undefined;
  return render(
    <BasicEmailWrapper footer={<MarketingFooter />}>
      <Heading>No paid card checkout in the last {hours ?? 'few'} hours</Heading>
      <p>
        The last paid course sale through Stripe completed at{' '}
        {lastPaidSaleAt ? lastPaidSaleAt.toISOString() : 'an unknown time'}. Free enrollments and
        PayPal are not counted, so they may still be arriving.
      </p>
      <p>
        Check a paid checkout page with an empty card. If Buy Now shows anything other than the
        card's own validation message, card checkout is down. Render logs for the prod service show
        browser-side failures under [checkout][client-error].
      </p>
      <p>
        This alert repeats at most once every 12 hours. It stops on its own once no paid sale has
        landed for 7 days.
      </p>
    </BasicEmailWrapper>,
  );
}
